/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLightbulbPreferences = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.003 2c3.41 0 6.225 2.534 6.86 5.81l-1.962.38C16.434 5.782 14.383 4 12.003 4h-.05l-.242.012c-2.49.19-4.583 2.339-4.706 5.023a5.158 5.158 0 0 0 1.445 3.849A5.606 5.606 0 0 1 9.74 15H11v-4h2v4h1.242c.178-.58.46-1.137.863-1.632l1.55 1.264c-.433.532-.653 1.234-.653 1.98V17H16v1a4 4 0 1 1-8 0v-1.555c-.043-.76-.377-1.537-.99-2.174a7.158 7.158 0 0 1-2.004-5.326v-.002C5.18 5.181 8.202 2.092 11.903 2zM10 18a2 2 0 0 0 4 0v-1h-4zm14 4h-2v-2h-4v-2h4v-2h2z" />
        <path d="M20 12h4v2h-4v2h-2v-6h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgLightbulbPreferences as LightbulbPreferences };
